<template>
  <div class="animate pulse w-full xl:h-[655px]">
    <div
      class="xl:h-full xl:grid xl:grid-cols-2 border border-secondary-300/40 rounded-xl overflow-hidden">
      <div
        class="relative w-full h-96 xl:h-full bg-neutral-600/40 xl:rounded-tl-xl xl:rounded-bl-xl xl:col-start-1 xl:row-span-3 xl:self-end">
        <div
          class="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 bg-secondary-900 p-2 rounded-xl">
          <svg
            class="h-12 w-12 text-gray-300 dark:text-gray-600 opacity-40"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 640 512">
            <path
              d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
          </svg>
        </div>
      </div>
      <div class="h-96 xl:h-full xl:col-start-2 xl:row-span-3 flex flex-col">
        <div class="h-32 px-4 border-b border-secondary-300/40">
          <div class="my-4 h-4 w-48 bg-neutral-600/40 rounded-xl"></div>
          <div class="my-4 h-3 w-36 bg-neutral-600/40 rounded-xl"></div>
        </div>
        <div class="h-32 px-4">
          <div class="my-4 h-2 w-full bg-neutral-600/40 rounded-xl"></div>
          <div class="px-4 my-4 h-2 w-full bg-neutral-600/40 rounded-xl"></div>
          <div class="px-4 my-4 h-2 w-2/3 bg-neutral-600/40 rounded-xl"></div>
        </div>
      </div>
    </div>
  </div>
</template>
